const DETAIL_FALLBACK = 'Something went wrong.';

const readDetailFromJson = (raw: string): string | undefined => {
  const jsonStart = raw.indexOf('{');
  if (jsonStart < 0) return undefined;
  try {
    const parsed = JSON.parse(raw.slice(jsonStart)) as {
      detail?: unknown;
      title?: unknown;
    };
    if (typeof parsed.detail === 'string' && parsed.detail.trim()) {
      return parsed.detail;
    }
    if (typeof parsed.title === 'string' && parsed.title.trim()) {
      return parsed.title;
    }
  } catch {
    return undefined;
  }
  return undefined;
};

export const getApiErrorMessage = (
  err: unknown,
  fallback = DETAIL_FALLBACK
): string => {
  if (err instanceof Error && err.message) {
    return readDetailFromJson(err.message) ?? err.message;
  }
  if (typeof err === 'object' && err !== null) {
    const rec = err as { detail?: unknown; message?: unknown };
    if (typeof rec.detail === 'string' && rec.detail.trim()) return rec.detail;
    if (typeof rec.message === 'string' && rec.message.trim()) {
      return readDetailFromJson(rec.message) ?? rec.message;
    }
  }
  return fallback;
};
